import * as React from "react";
import NewButton from "../uiMerge/newButton";
import { useNavigate } from "react-router-dom";
import { NewModal } from "../uiMerge/newModal";
import ErrorIcon from "../../assets/svg/failedNewIcon.svg";
import * as ROUTES from "../../constants/routes";
import { openSupportEscalationMail } from "../../utils/supportEscalation";

type SupportIssue = {
  message: string;
  errorCode?: string;
  supportRef?: string;
};

interface VerificationFailedModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: () => void;
  supportIssue?: SupportIssue | null;
  errorCount?: number;
  operationName?: string;
  extraContext?: Record<string, string | number | boolean | null | undefined>;
}

export const VerificationFailedModal: React.FC<VerificationFailedModalProps> = ({
  visible,
  onCancel,
  onOk,
  supportIssue,
  errorCount = 0,
  operationName,
  extraContext,
}) => {
  const navigate = useNavigate();

  return (
    <NewModal
      isOpen={visible}
      colorClass="bg-[#1E1E1E]"
      roundedClass="rounded-2xl"
      widthClass="w-[350px]"
      showCloseButton={false}
      animationClass="grow-in"
      position="center"
      onClose={onCancel}
      onOk={onOk}
    >
      <div className="p-5 text-white flex flex-col min-h-[38vh] justify-center items-center">
        <div className="text-center w-[250px] gap-y-2 flex flex-col justify-center items-center">
          <div className="pb-4">
            <img src={ErrorIcon} alt="failed" />
          </div>

          <div className="flex flex-col items-center space-y-2">
            <p className="text-2xl font-bold">Verification Failed!</p>
            <p className="text-md text-[#CECECF] font-normal">
              We couldn't verify your ID. Please try again.
            </p>
          </div>

          <div className="w-full pt-5 flex flex-col">
            <NewButton
              variant="outline"
              fullWidth
              onClick={() => navigate(ROUTES.HOME)}
            >
              Try Again
            </NewButton>
          </div>
          {errorCount >= 3 && (
            <p className="text-center w-full">
              <button
                type="button"
                onClick={() =>
                  openSupportEscalationMail({
                    actionName: "Identity Verification",
                    errorMessage: supportIssue?.message || "ID verification failed.",
                    errorCode: supportIssue?.errorCode,
                    supportRef: supportIssue?.supportRef,
                    operationName: operationName || "AddIdentityMutation",
                    extra: extraContext,
                  })
                }
                className="text-center !text-[#C553FC]"
              >
                Need help?
              </button>
            </p>
          )}
        </div>
      </div>
    </NewModal>
  );
};